import React, { useState } from 'react'
import { Box, TextField, Typography, ClickAwayListener, Button, Chip, FormControl, InputLabel, Select, MenuItem, Checkbox, FormControlLabel } from '@mui/material'
import { CloudUpload as CloudUploadIcon } from '@mui/icons-material'
import { useSurveyStore } from '../../surveyutilities/surveyStore'

function FileUploadBlock({ block, position }) {
    const [editingTitle, setEditingTitle] = useState(false);
    const [editingDescription, setEditingDescription] = useState(false);
    const updateQuestion = useSurveyStore((state) => state.updateQuestion);

    const handleTitleClick = () => setEditingTitle(true);
    const handleDescriptionClick = () => setEditingDescription(true);
    const handleClickAway = () => {
        setEditingTitle(false);
        setEditingDescription(false);
    };

    const handleTitleChange = (event) => {
        updateQuestion(block.internalId, { title: event.target.value });
    };

    const handleDescriptionChange = (event) => {
        updateQuestion(block.internalId, { description: event.target.value });
    };

    const handleFileTypesChange = (event) => {
        updateQuestion(block.internalId, { acceptedFileTypes: event.target.value });
    };

    const handleMaxSizeChange = (event) => {
        updateQuestion(block.internalId, { maxFileSize: parseInt(event.target.value) });
    };

    const handleMultipleChange = (event) => {
        updateQuestion(block.internalId, { allowMultiple: event.target.checked });
    };

    const fileTypeOptions = [
        'image/*',
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'text/plain',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ];

    return (
        <Box>
            <ClickAwayListener onClickAway={handleClickAway}>
                <Box>
                    {editingTitle ? (
                        <TextField
                            autoFocus
                            fullWidth
                            value={block.title}
                            onChange={handleTitleChange}
                            onBlur={handleClickAway}
                            variant="outlined"
                            sx={{ mb: 1 }}
                        />
                    ) : (
                        <Typography
                            sx={{ mb: 1, cursor: 'pointer', '&:hover': { backgroundColor: '#f5f5f5' } }}
                            onClick={handleTitleClick}
                        >
                            {position + 1}. {block.title} {block.required ? <span style={{color: 'red'}}>*</span> : ''}
                        </Typography>
                    )}

                    {editingDescription ? (
                        <TextField
                            autoFocus
                            fullWidth
                            value={block.description}
                            onChange={handleDescriptionChange}
                            onBlur={handleClickAway}
                            variant="outlined"
                            multiline
                            maxRows={4}
                            sx={{ mb: 1 }}
                        />
                    ) : (
                        <Typography
                            variant="body2"
                            sx={{ mb: 1, cursor: 'pointer', '&:hover': { backgroundColor: '#f5f5f5' } }}
                            onClick={handleDescriptionClick}
                        >
                            {block.description}
                        </Typography>
                    )}

                    <Box sx={{ border: '2px dashed #ccc', borderRadius: 2, p: 3, textAlign: 'center', mb: 2 }}>
                        <CloudUploadIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 1 }} />
                        <Typography variant="h6" gutterBottom>
                            Drag and drop files here
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                            or
                        </Typography>
                        <Button variant="contained" component="span" disabled>
                            Browse Files
                        </Button>
                    </Box>

                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                        <InputLabel>Accepted File Types</InputLabel>
                        <Select
                            multiple
                            value={block.acceptedFileTypes || []}
                            onChange={handleFileTypesChange}
                            label="Accepted File Types"
                            renderValue={(selected) => (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                    {selected.map((value) => (
                                        <Chip key={value} label={value} size="small" />
                                    ))}
                                </Box>
                            )}
                        >
                            {fileTypeOptions.map((type) => (
                                <MenuItem key={type} value={type}>
                                    <Checkbox checked={block.acceptedFileTypes?.includes(type) || false} />
                                    {type}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                        <TextField
                            label="Max File Size (MB)"
                            type="number"
                            value={block.maxFileSize || 5}
                            onChange={handleMaxSizeChange}
                            size="small"
                            sx={{ width: 150 }}
                        />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={block.allowMultiple || false}
                                    onChange={handleMultipleChange}
                                />
                            }
                            label="Allow Multiple Files"
                        />
                    </Box>
                </Box>
            </ClickAwayListener>
        </Box>
    );
}

export default FileUploadBlock;